import { string, node, oneOf } from 'prop-types'
import Bar from '../../Bar'
import { kuiperClassNames } from '../../utils'

const Header = ({ align, className, children, color, height }) => (
  <Bar
    className={kuiperClassNames('bar header', className)}
    align={align}
    height={height}
    color={color}
  >
    {children}
  </Bar>
)

Header.propTypes = {
  align: string,
  children: node,
  className: string,
  color: string,
  height: oneOf(['small', 'medium', 'large']),
}

export default Header
